import { DateSelectionT } from "./types"

function parseDMY(str: string): Date {
  const [day, month, year] = str.split("/").map(Number)
  return new Date(year, month - 1, day)
}

export function dateSorter(dates: DateSelectionT[]) {
  const today = new Date()
  const filtered = dates?.filter((item) => {
    if (!item?.date) return
    const d = parseDMY(item.date)
    return d.getTime() >= today.getTime() - 24 * 60 * 60 * 1000
  })

  return filtered
}

type EventMetaLike = {
  dateType?: string | null
  date?: string | null
  startDate?: string | null
  dateSelection?: (DateSelectionT | null)[] | null
}

export function getEventSortDate(eventMeta: EventMetaLike | null | undefined): Date {
  const fallback = new Date(8640000000000000)
  if (!eventMeta) return fallback

  if (eventMeta.dateType === "single") {
    return eventMeta.date ? parseDMY(eventMeta.date) : fallback
  }

  if (eventMeta.dateType === "repeating") {
    return eventMeta.startDate ? parseDMY(eventMeta.startDate) : fallback
  }

  if (eventMeta.dateType === "selection" && eventMeta.dateSelection) {
    const today = new Date()
    const cutoff = today.getTime() - 24 * 60 * 60 * 1000
    const allDates = eventMeta.dateSelection
      .filter((s): s is DateSelectionT => !!s?.date)
      .map((s) => parseDMY(s.date!))
      .sort((a, b) => a.getTime() - b.getTime())
    const upcoming = allDates.filter((d) => d.getTime() >= cutoff)
    if (upcoming[0]) return upcoming[0]
    return allDates[allDates.length - 1] ?? fallback
  }

  return fallback
}
